import { BASE_API } from "../../../constants/api";
import axiosHttp from "../../interceptors/axios-interceptor";

export default function GetAdminPricingSnapshotV2(userId) {
    const api = `${BASE_API}v2/admins/${userId}/pricing/snapshot/`;
    return axiosHttp.get(api, { params: { includePriceUpdate: true } });
}